import _ from 'lodash'
import Highcharts from 'highcharts'
import { tabNames } from './analyzeresult'
import chartDataService from '../service/chartoption'
import Vue from 'vue'

const chartOptions = {
  IF00002: {
    title: '性年代別購入者分析',
    type: 'spline'
  },
  IF00003: {
    title: 'ABCL分析',
    type: 'xy',
    yAxis: [
      { // Primary yAxis
        labels: {
          format: '{value}%',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        title: {
          text: '点数構成比',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      },
      { // Secondary yAxis
        title: {
          text: 'リピート率',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        labels: {
          format: '{value} %',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        opposite: true
      }
    ],
    legend: {
      layout: 'horizontal',
      align: 'center',
      x: 0,
      verticalAlign: 'bottom',
      y: 0,
      itemWidth: 200,
      enabled: true,
      backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF'
    },
    series: [{
      name: '点数構成比',
      type: 'column',
      yAxis: 0,
      data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0],
      tooltip: {
        pointFormatter: function () {
          let point = this
          return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(2) + '%</b><br/>'
        }
      }
    },
    {
      name: 'リピート率',
      type: 'spline',
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5],
      tooltip: {
        pointFormatter: function () {
          let point = this
          return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(2) + '%</b><br/>'
        }
      }
    }],
    xAxis: [{
      categories: [],
      crosshair: true,
      labels: {
        rotation: 90
      }
    }]
  },
  IF00004: {
    chart: {
      type: 'bubble',
      plotBorderWidth: 1,
      zoomType: 'xy'
    },
    legend: {
      enabled: false
    },
    title: {
      text: 'トライアルリピート'
    },
    xAxis: {
      gridLineWidth: 1,
      title: {
        text: 'リピート率'
      },
      labels: {
        format: '{value} %'
      },
      plotLines: [{
        color: 'black',
        dashStyle: 'dot',
        width: 2,
        value: 65,
        label: {
          rotation: 0,
          y: 15,
          style: {
            fontStyle: 'italic'
          },
          text: 'リピート率'
        },
        zIndex: 3
      }]
    },
    yAxis: {
      startOnTick: false,
      endOnTick: false,
      title: {
        text: 'トライアル率'
      },
      labels: {
        format: '{value} %'
      },
      maxPadding: 0.2,
      plotLines: [{
        color: 'black',
        dashStyle: 'dot',
        width: 2,
        value: 50,
        label: {
          align: 'right',
          style: {
            fontStyle: 'italic'
          },
          text: 'トライアル率',
          x: -10
        },
        zIndex: 3
      }]
    },
    tooltip: {
      useHTML: true,
      headerFormat: '<table>',
      pointFormat: '<tr><th colspan="2"><h3>{point.detail}</h3></th></tr>' +
        '<tr><th>{repeat_rate}：</th><td>{point.x}%</td></tr>' +
        '<tr><th>{trial_rate}：</th><td>{point.y}%</td></tr>',
      footerFormat: '</table>',
      followPointer: true
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      },
      bubble: {
        maxSize: 20,
        minSize: 20
      }
    },
    series: [{
      data: [
        { x: 95, y: 95, name: 'BE', detail: 'Belgium' },
        { x: 86.5, y: 102.9, name: 'DE', detail: 'Germany' }
      ]
    }],
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  },
  IF00005: {
    chartOptions: {
      xAxis: [
        {
          categories: []
        }
      ]
    },
    chart: {
      type: 'line',
      zoomType: 'x'
    },
    title: {
      text: 'トレンド分析'
    },
    subtitle: {
      text: '買上点数'
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: 90
      }
    },
    yAxis: {
      title: {
        text: '買上点数'
      }
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      x: 0,
      y: 0,
      itemWidth: 200,
      enabled: true
    },
    series: [],
    credits: {
      enabled: false
    },
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  },
  IF00006: {
    chartOptions: {
      xAxis: [
        {
          categories: [],
          labels: {
            rotation: 90
          }
        }
      ]
    },
    chart: {
      type: 'xy',
      zoomType: 'x'
    },
    title: {
      text: 'バスケット分析'
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: 90
      }
    },
    yAxis: [
      { // Primary yAxis
        labels: {
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        title: {
          text: 'リフト値',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      },
      { // Secondary yAxis
        title: {
          text: '同時併買率',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        labels: {
          format: '{value}%',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        opposite: true
      }
    ],
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      x: 0,
      y: 0,
      itemWidth: 200,
      enabled: true
    },
    series: [{
      name: '同時併買率',
      type: 'line',
      yAxis: 1,
      data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0],
      tooltip: {
        valueSuffix: ' %'
      }
    },
    {
      name: 'リフト値',
      type: 'line',
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5]
    }],
    credits: {
      enabled: false
    },
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  },
  IF00007: {
    chartOptions: {
      xAxis: [
        {
          categories: [],
          labels: {
            rotation: 90
          }
        }
      ]
    },
    chart: {
      type: 'xy',
      zoomType: 'x'
    },
    title: {
      text: '併買分析'
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: 90
      }
    },
    yAxis: [
      { // Primary yAxis
        labels: {
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        title: {
          text: '併買者数',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      },
      { // Secondary yAxis
        title: {
          text: '併買率',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        labels: {
          format: '{value}%',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        opposite: true
      }
    ],
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      x: 0,
      y: 0,
      itemWidth: 200,
      enabled: true
    },
    series: [{
      name: '併買率',
      type: 'line',
      yAxis: 1,
      data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0],
      tooltip: {
        valueSuffix: ' %'
      }
    },
    {
      name: '併買者数',
      type: 'line',
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5]
    }],
    credits: {
      enabled: false
    },
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  },
  IF00010: {
    chart: {
      type: 'column'
    },
    title: {
      text: '商品別売上分析'
    },
    subtitle: {
      text: ''
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: 90
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: '金額'
      }
    },
    tooltip: {
      pointFormatter: function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y.toFixed(2) + '%</b><br/>'
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    series: [{
      name: '売上数量',
      data: []
    }],
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  },
  IF00011: {
    chartOptions: {
      xAxis: [
        {
          categories: []
        }
      ]
    },
    chart: {
      type: 'line',
      zoomType: 'x'
    },
    title: {
      text: 'ABC分析'
    },
    subtitle: {
      text: '基準期間（YYYY-MM-DD 〜 YYYY-MM-DD）'
    },
    xAxis: {
      categories: [],
      labels: {
        rotation: 90
      }
    },
    yAxis: {
      title: {
        text: '数量構成比'
      }
    },
    tooltip: {
      pointFormatter: function () {
        let point = this
        return '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': <b>' + point.y + '%</b><br/>'
      }
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true
        }
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      x: 0,
      y: 0,
      itemWidth: 200,
      enabled: true
    },
    series: [],
    credits: {
      enabled: false
    },
    exporting: {
      sourceWidth: 1250,
      sourceHeight: 600,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
        }
      }
    }
  }
}

const basicData = {
  chart: {
    type: '',
    zoomType: 'x',
    backgroundColor: '#ffffff'
  },
  title: {
    text: ''
  },
  subtitle: {
    text: ''
  },
  xAxis: {
    categories: []
  },
  yAxis: {
    title: {
      text: ''
    },
    labels: {
      formatter: function () {
        return this.value + ''
      }
    }
  },
  tooltip: {
    crosshairs: true,
    shared: true
  },
  credits: {
    enabled: false
  },
  plotOptions: {
    spline: {
      marker: {
        radius: 4,
        lineColor: '#058DC7',
        lineWidth: 1
      }
    }
  },
  exporting: {
    sourceWidth: 1250,
    sourceHeight: 600,
    buttons: {
      contextButton: {
        menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG']
      }
    }
  },
  series: []
}

export default {
  getBasicChartOption (analyzeId) {
    let chartData = _.cloneDeep(basicData)
    if (_(chartOptions).has(analyzeId)) {
      let chartOption = _(chartOptions).get(analyzeId)
      chartData.title.text = chartOption.title
      chartData.chart.type = chartOption.type
      if (analyzeId === 'IF00002') {
        const purchaseIndexName = this.getLegend('purchase_index', '購入指数(%)')
        chartData.yAxis.title.text = purchaseIndexName
        let series = {
          name: purchaseIndexName,
          data: []
        }
        chartData.series.push(series)
      } else if (analyzeId === 'IF00003') {
        chartData.series = chartOption.series
        chartData.yAxis = chartOption.yAxis
        chartData.xAxis = chartOption.xAxis
        chartData.legend = chartOption.legend
      } else if (analyzeId === 'IF00004') {
        chartData = _.cloneDeep(chartOption)
      } else if (analyzeId === 'IF00005') {
        chartData = chartOption
        let series = [{
          name: '買上点数',
          data: []
        }]
        chartData.series = series
      } else if (analyzeId === 'IF00006' || analyzeId === 'IF00007') {
        chartData = chartOption
      } else if (analyzeId === 'IF00010') {
        chartData = _.cloneDeep(chartOption)
      } else if (analyzeId === 'IF00011') {
        chartData = chartOption
        let series = [{
          name: '数量構成比',
          data: []
        }]
        chartData.series = series
      }
    }
    return chartData
  },
  getAges (age) {
    let ages = []
    let minAge = 10
    let maxAge = 80
    let label = ''
    for (let ag = minAge; ag <= maxAge; ag += age) {
      if (age === 5) {
        if (ag === 10) {
          ages.push('10歳未満')
        } else if (ag === 80) {
          ages.push('80歳以上')
        }
        if (ag < 80) {
          label = ag + '～' + (ag + age - 1) + '歳'
          ages.push(label)
        }
      } else {
        if (ag === 10) {
          ages.push('10歳未満')
        } else if (ag === 80) {
          ages.push('80歳以上')
        }
        if (ag < 80) {
          ages.push(ag + '代')
        }
      }
    }
    return ages
  },
  getAgesFromDb (agesInDb, age) {
    const ages = agesInDb['age_' + age]
    if (!ages) {
      return []
    }
    return _.map(ages, 'name')
  },
  getAgesData (categories) {
    let ages = {}
    _.forEach(categories, function (item) {
      _.set(ages, item, 0)
    })
    return ages
  },
  getAgeKey (value, age) {
    let ageValue = _.replace(value, '歳', '')
    let ages = _.split(ageValue, '～', 2)
    let minAge = 10
    let maxAge = 95
    for (let ag = minAge; ag <= maxAge; ag += age) {
      if (ag < parseInt(ages[1]) && (ag === parseInt(ages[0]))) {
        return ag + '代'
      }
    }
  },
  getGender (value) {
    // BQテーブルのgender（性別）フィールド：男、女、1、2など混在、男性、女性に統一する
    // こちらも一応互換できるにする
    if (value === '1' || value === '男' || value === '男性') {
      return '1'
    } else if (value === '2' || value === '女' || value === '女性') {
      return '2'
    }
    return null
  },
  getGenderDisplay (value) {
    // BQテーブルのgender（性別）フィールド：男、女、1、2など混在、男性、女性に統一する
    // こちらも一応互換できるにする
    const gender = this.getGender(value)
    if (gender === '1') {
      return '男性'
    } else if (gender === '2') {
      return '女性'
    }
    return value
  },
  getIF00005Title (typeMode) {
    let title = '期間併買'
    if (typeMode === 0) {
      title = '期間併買'
    } else if (typeMode === 1) {
      title = '直前期間購入者分析'
    } else if (typeMode === 2) {
      title = '直後期間購入者分析'
    }
    return title
  },
  getIF00004Detail (type) {
    let detail = '期間併買'
    if (type === 'all') {
      detail = '全体'
    } else if (type === 'age_10') {
      detail = '性年代別(10歳刻み)'
    } else if (type === 'age_5') {
      detail = '性年代別(5歳刻み)'
    }
    return detail
  },
  getDefaultTab (analyzeTargetCode) {
    if (_(tabNames).has(analyzeTargetCode)) {
      let tabs = _(tabNames).get(analyzeTargetCode)
      return tabs[0].key
    }
    return null
  },
  hasChart (analyzeTargetCode) {
    return _(chartOptions).has(analyzeTargetCode)
  },
  hasChartByTabs (analyzeTargetCode, tabType) {
    if (analyzeTargetCode === 'IF00002' ||
      (analyzeTargetCode === 'IF00003' && tabType === 'item') ||
      analyzeTargetCode === 'IF00004' ||
      (analyzeTargetCode === 'IF00005' && tabType === 'all') ||
      analyzeTargetCode === 'IF00006' ||
      analyzeTargetCode === 'IF00007' ||
      (analyzeTargetCode === 'IF00010' && tabType !== '') ||
      analyzeTargetCode === 'IF00011') {
      return true
    }
    return false
  },
  createChartOptions (chartDetailInfo, analyzeTargetCode, conditionsGroupby, conditionsTypeMode, tabType, yAxis, term, ages) {
    let basicData = chartDataService.getBasicChartOption(analyzeTargetCode)
    let stateChartOptions = []
    let chartOptions = null

    if (analyzeTargetCode === 'IF00002') {
      stateChartOptions = chartDataService.buildIF0002ChartData(basicData, tabType, chartDetailInfo, ages)
    } else if (analyzeTargetCode === 'IF00003') {
      chartOptions = chartDataService.buildIF0003ChartData(basicData, tabType, chartDetailInfo, yAxis)
      if (chartOptions !== null) {
        chartOptions.chart.zoomType = ''
        chartOptions.chart.scrollablePlotArea = { minWidth: 25 * chartDetailInfo.length }
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00004') {
      chartOptions = chartDataService.buildIF0004ChartData(basicData, tabType, chartDetailInfo, conditionsGroupby)
      if (chartOptions !== null) {
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00005') {
      chartOptions = chartDataService.buildIF0005ChartData(basicData, tabType, chartDetailInfo, conditionsGroupby)
      if (chartOptions !== null) {
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00006') {
      chartOptions = chartDataService.buildIF0006ChartData(basicData, tabType, chartDetailInfo, conditionsGroupby)
      if (chartOptions !== null) {
        chartOptions.chart.zoomType = ''
        chartOptions.chart.scrollablePlotArea = { minWidth: 25 * chartDetailInfo.length }
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00007') {
      chartOptions = chartDataService.buildIF0007ChartData(basicData, tabType, chartDetailInfo, conditionsTypeMode)
      if (chartOptions !== null) {
        chartOptions.chart.zoomType = ''
        chartOptions.chart.scrollablePlotArea = { minWidth: 25 * chartDetailInfo.length }
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00010') {
      chartOptions = chartDataService.buildIF0010ChartData(basicData, tabType, chartDetailInfo, yAxis)
      if (chartOptions !== null) {
        chartOptions.chart.zoomType = ''
        chartOptions.chart.scrollablePlotArea = { minWidth: 25 * chartDetailInfo.length }
        stateChartOptions.push(chartOptions)
      }
    } else if (analyzeTargetCode === 'IF00011') {
      chartOptions = chartDataService.buildIF0011ChartData(basicData, chartDetailInfo, term, yAxis)
      if (chartOptions !== null) {
        stateChartOptions.push(chartOptions)
      }
    }

    console.log('stateChartOptions', stateChartOptions)
    return stateChartOptions
  },
  IF00010YAXIS () {
    const allowedColumns = [
      'base_purchase_qty',
      'base_purchase_price',
      'base_purchase_price_average',
      'base_special_sale_qty',
      'base_special_sale_price',
      'base_special_sale_rate_qty',
      'base_special_sale_rate_price',
      'base_pi_qty',
      'base_pi_price'
    ]

    const aggregateFixedColumns = JSON.parse(Vue.localStorage.get('aggregate_fixed_columns', []))
    return aggregateFixedColumns
      .filter(col => allowedColumns.includes(col.column))
      .map(col => ({
        cd: col.column,
        name: col.name
      }))
  },
  getIF00010YTitle (yAxis) {
    let items = _.filter(this.IF00010YAXIS(), (item) => {
      return item.cd === yAxis
    })
    if (items.length === 1) {
      return items[0]['name']
    }
    return this.getLegend('base_purchase_qty', '売上数量')
  },
  IF00003YAXIS () {
    const allowedColumns = [
      'purchase_qty_composition_rate_card',
      'purchase_price_composition_rate_card'
    ]

    const aggregateFixedColumns = JSON.parse(Vue.localStorage.get('aggregate_fixed_columns', []))
    return aggregateFixedColumns
      .filter(col => allowedColumns.includes(col.column))
      .map(col => ({
        cd: col.column,
        name: col.name
      }))
  },
  getIF00003YTitle (yAxis) {
    let items = _.filter(this.IF00003YAXIS(), (item) => {
      return item.cd === yAxis
    })
    if (items.length === 1) {
      return items[0]['name']
    }
    return this.getLegend('purchase_qty_composition_rate_card', '点数構成比')
  },
  IF00011YAXIS () {
    const allowedColumns = [
      'base_purchase_qty_composition_rate',
      'base_purchase_price_composition_rate'
    ]

    const aggregateFixedColumns = JSON.parse(Vue.localStorage.get('aggregate_fixed_columns', []))
    return aggregateFixedColumns
      .filter(col => allowedColumns.includes(col.column))
      .map(col => ({
        cd: col.column,
        name: col.name
      }))
  },
  getIF00011YTitle (yAxis) {
    let items = _.filter(this.IF00011YAXIS(), (item) => {
      return item.cd === yAxis
    })
    if (items.length === 1) {
      return items[0]['name']
    }
    return this.getLegend('base_purchase_qty_composition_rate', '数量構成比')
  },
  getStoreCondition (item) {
    // 1186
    // 集約項目に店舗関連がある場合は'99999'のデータを使ってグラフを作成する。
    // ない場合は、性年代別は店舗コード''のデータを使ってグラフを作成する。
    return 'store_cd' in item ? item.store_cd === '99999' : item.store_cd === ''
  },
  getLegend (cd, defaultName) {
    const aggregateFixedColumns = JSON.parse(Vue.localStorage.get('aggregate_fixed_columns', []))
    const column = aggregateFixedColumns.find(col => col.column === cd)
    return column ? column.name : defaultName
  }
}
